export default __webpack_public_path__ + "static/media/info-tramo.288387a7.svg";